import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { loginSso } from '../../actions';
import { Text } from '../../components/common/Text';
import visitLogo from '../../images/common/visitlogo.png';

const OuterContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;
`;

const Logo = styled.img`
  width: 60px;
  margin-bottom: 12px;
`;

function CheckIfWebViewIos() {
  var userAgent = window.navigator.userAgent.toLowerCase(),
    safari = /safari/.test(userAgent),
    ios = /iphone|ipod|ipad/.test(userAgent);

  if (ios) {
    if (safari) {
      return false;
    } else if (!safari) {
      return true;
    }
  } else {
    return false;
  }
}

export default function UniversalSsoContainer(props) {
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const searchParams = new URLSearchParams(props.location.search);
  const userAgent = window.navigator.userAgent.toLowerCase();
  const universalSsoExists = false;
  const history = props.history;
  const location = props.location;
  useEffect(() => {
    if (searchParams.get('userParams') && searchParams.get('clientId')) {
      if (
        searchParams.get('clientId').includes('axis') &&
        (window.Android === undefined || window.Android === 'undefined') &&
        !window.ReactNativeWebView &&
        !CheckIfWebViewIos() &&
        !userAgent.includes('wv')
      ) {
        history.replace('/login');
      } else {
        dispatch(
          loginSso(
            searchParams.get('userParams'),
            searchParams.get('clientId'),
            history,
            user,
            null,
            universalSsoExists
          )
        );
      }
    } else {
      history.push({
        pathname: '/login',
        search: location.search,
      });
    }
  }, []);

  return (
    <OuterContainer>
      <Logo src={visitLogo} />
      <Text>Loading, Please wait...</Text>
    </OuterContainer>
  );
}
